import type { FC } from 'react'

import { StyledText } from '@skytech/ui'
import { Button } from '@skytech/ui/Button'
import { useNavigate } from 'react-router-dom'
import { twMerge } from 'tailwind-merge'

import Highlight from '@/components/Highlight'

import { useLeasedAssets } from '../AssetsLeased.context'

export const AssetLink: FC<{
  className?: string
  searchFilter: string
  assetText: string
  showPopup: boolean
  isLinkValid: boolean
  link: string
  onAssetClick: () => void
}> = ({ className, searchFilter, assetText, showPopup, isLinkValid, link, onAssetClick }) => {
  if (!isLinkValid) {
    return <Highlight pattern={searchFilter} text={assetText} />
  }

  const { selectedList } = useLeasedAssets()
  const navigate = useNavigate()

  const handleOnClick = () => {
    showPopup && selectedList.length !== 0 ? onAssetClick() : navigate(link)
  }

  return (
    <Button
      className="leading-2 m-0 p-0 no-underline"
      variant="tertiary"
      size="small"
      onClick={e => {
        e.stopPropagation()
        handleOnClick()
      }}
    >
      <StyledText className={twMerge('underline', className)} size="regular-plus">
        <Highlight pattern={searchFilter} text={assetText} />
      </StyledText>
    </Button>
  )
}
